import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { IndexComponent } from './index/index.component';
import { CompanyComponent } from './company/company.component';
import { ProductsComponent } from './products/products.component';
import { ContactComponent } from './contact/contact.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';

export const router: Routes = [
  { path: '', component: IndexComponent },
  { path: 'sobre', component: CompanyComponent },
  { path: 'produtos', component: ProductsComponent },
  { path: 'contato', component: ContactComponent },
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// C:/xampp/htdocs/corpo-leve-www/www/src/app/app.router.ts